// Nextech IDP Admin Console environment config (qa) - swapped in for
// environment.ts by the `qa` build configuration (fileReplacements).
//
// Values come from the admin-console terraform outputs on the qa workspace
// (nextech-group-idp-admin-console-web-service/terraform, qa.tfvars).
export const environment = {
    production: false,
    // Base URL of nextech-group-idp-admin-console-web-service on qa Cloud Run
    // (scripts\cloud-run-qa.bat in that repo; app-layer ID-token auth, open
    // invoker). For a locally-run backend use 'http://localhost:8080'.
    apiBaseUrl: 'https://ngidp-admin-console-ws-258011513598.europe-west1.run.app',
    firebase: {
        apiKey: "AIzaSyBeRK5IF1PoyAWQqFEAe8Be9g1vqy1XsRc",
        authDomain: "pkg-digi-grp-qa-ecom-idp.firebaseapp.com",
        projectId: "pkg-digi-grp-qa-ecom-idp",
        storageBucket: "",
        messagingSenderId: "258011513598",
        appId: "1:258011513598:web:038966928f8aff399b1baf"
    },
    // GCIP tenant id the Google Workspace login authenticates against
    // (terraform output admin_tenant_id, qa workspace).
    firebaseTenantId: 'admin-console-users-q1v87',
    // No `hd` hint on qa: external testers sign in with non-flatrock Google
    // accounts. Access is still invite-only via the blocking functions'
    // AdminInvites allowlist (domain lock relaxed by AdminConsoleConfig/auth).
    googleHostedDomainHint: null as string | null,
    // Show the email/password login fields alongside Google sign-in. Kept OFF so
    // the UI is Google-Workspace-only (the email/password path stays in the code);
    // flip to true when email/password is needed for local testing.
    enableEmailPasswordLogin: false
};
